<div class="tooltip-box p-3">
  <div class="caption" [innerHTML]="text"></div>
  <span class="arrow"></span>
</div>
